import { render, staticRenderFns } from "./LoadingSplash.vue?vue&type=template&id=0b7a0222&"
import script from "./LoadingSplash.vue?vue&type=script&lang=js&"
export * from "./LoadingSplash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports